import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { SourcesScreen } from '@/features/sources/SourcesScreen';
import { useTenant } from '@/lib/tenant';

function SourcesRoute() {
  const { slug } = Route.useParams();
  const { setSlug } = useTenant();
  useEffect(() => {
    setSlug(slug);
  }, [slug, setSlug]);
  return <SourcesScreen slug={slug} />;
}

export const Route = createFileRoute('/tenants/$slug/sources')({
  component: SourcesRoute,
});
